import { PlanProgressBarComponent } from './components/plan-progress-bar/plan-progress-bar.component';
import { PaymentSelectorComponent } from './components/payment-selector/payment-selector.component';
//#region modules
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
//#endregion

//#region react components
import { ReactComponentsModule } from './react-components/react-components.module';
import { AclNgxModule } from '@amobee/acl-ngx';
//#endregion

//#region external depedencies
import { AmobeeLoaderComponent } from './components/loader/amobee-loader.component';
import { AutoCompleteModule } from './components/auto-complete/auto-complete.module';
import { NgMultiSelectDropDownModule } from './components/ng-multiselect-dropdown/ng-multiselect-dropdown.module';
import { CheckboxTreeModule } from './components/checkbox-tree/checkbox-tree.module';
import { DataTableModule } from './components/data-table/data-table.module';
import { ModalModule } from './components/modal/modal.module';
import { DirectivesModule } from './directives/directives.module';
import { AclCollapsibleNavItemsWrapperComponent } from './components/acl-collapsible-nav-items-wrapper/acl-collapsible-nav-items-wrapper.component';
import { TimezonePipe } from './pipes/timezone.pipe';
import { FormTitleComponent } from './components/form-title/form-title.component';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { FooterComponent } from './components/footer/footer.component';
import { FormSideNavBarComponent } from './components/form-side-nav-bar/form-side-nav-bar.component';
import { RedirectComponent } from './components/redirect/redirect.component';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from './pipes/safeHtmlPipe';
import { MessageNotificationModule } from './components/message-notification/message-notification.module';
import { PopoverListContentComponent } from './components/popover-list-content/popover-list-content.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
//#endregion

const components = [
    TimezonePipe,
    SafeHtmlPipe,
    AmobeeLoaderComponent,
    FormTitleComponent,
    PageTitleComponent,
    FooterComponent,
    FormSideNavBarComponent,
    RedirectComponent,
    AclCollapsibleNavItemsWrapperComponent,
    PopoverListContentComponent,
    PaymentSelectorComponent,
    UserProfileComponent,
    PlanProgressBarComponent
];

@NgModule({
    declarations: components,
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ReactComponentsModule,
        AclNgxModule,
        NgMultiSelectDropDownModule,
        HttpClientModule,
        CheckboxTreeModule,
        DataTableModule,
        ModalModule,
        AutoCompleteModule,
        DirectivesModule,
        MessageNotificationModule
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
        ...components,
        ReactComponentsModule,
        AclNgxModule,
        NgMultiSelectDropDownModule,
        CheckboxTreeModule,
        DataTableModule,
        ModalModule,
        AutoCompleteModule,
        DirectivesModule,
        MessageNotificationModule
    ]
})
export class AppCommonModule { }
